import { render, staticRenderFns } from "./BTRelatorioFrequenciaSaida.vue?vue&type=template&id=34beac20&scoped=true"
import script from "./BTRelatorioFrequenciaSaida.vue?vue&type=script&lang=js"
export * from "./BTRelatorioFrequenciaSaida.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34beac20",
  null
  
)

export default component.exports